import {
  PremiumPackage,
  Price,
} from '@project-gd-x/dating-site-contracts/src/gen/gdx/gateway/web/payment/v2/package_pb';
import { computed, reactive } from 'vue';

import { getFormattedCurrency, getPriceAlpha3Formatted } from '@/helpers/number';
import { getPackagePrice, getPackagePricePerWeek } from '@/pages/payment/helpers/package/package';
import { PaymentStatePackage } from '@/pages/payment/store/payment-state';
import { ExtractClassFields } from '@/type';

export function usePackagePrice(pkg: ExtractClassFields<PaymentStatePackage>) {
  const price = computed<ExtractClassFields<Price>>(() => {
    return getPackagePrice(pkg);
  });

  const priceFormatted = computed<string>(() => {
    return getFormattedCurrency(
      price.value.totalAmount - price.value.taxAmount,
      price.value.currency,
    );
  });

  const priceTotalFormatted = computed<string>(() => {
    return getFormattedCurrency(price.value.totalAmount, price.value.currency);
  });

  const priceTaxFormatted = computed<string>(() => {
    return getFormattedCurrency(price.value.taxAmount, price.value.currency);
  });

  const priceAlpha3Formatted = computed<string>(() => {
    return getPriceAlpha3Formatted(
      price.value.totalAmount - price.value.taxAmount,
      price.value.currency,
    );
  });

  const priceTotalAlpha3Formatted = computed<string>(() => {
    return getPriceAlpha3Formatted(price.value.totalAmount, price.value.currency);
  });

  const priceTaxAlpha3Formatted = computed<string>(() => {
    return getPriceAlpha3Formatted(price.value.taxAmount, price.value.currency);
  });

  return reactive({
    price,
    priceFormatted,
    priceTotalFormatted,
    priceTaxFormatted,
    priceAlpha3Formatted,
    priceTotalAlpha3Formatted,
    priceTaxAlpha3Formatted,
  });
}

export function usePackagePricePerWeek(pkg: ExtractClassFields<PremiumPackage>) {
  const price = computed<ExtractClassFields<Price>>(() => {
    return getPackagePricePerWeek(pkg);
  });

  const priceFormatted = computed<string>(() => {
    return getFormattedCurrency(
      price.value.totalAmount - price.value.taxAmount,
      price.value.currency,
    );
  });

  const priceTaxFormatted = computed<string>(() => {
    return getFormattedCurrency(price.value.taxAmount, price.value.currency);
  });

  return reactive({
    price,
    priceFormatted,
    priceTaxFormatted,
  });
}
